import { Configuration } from "../generate-client/configuration";
import { environment } from '../../environments/environment';

export function AppConfig(){
    return new Configuration({
    accessToken:()=>localStorage.getItem("token"), 
    basePath: environment.apiUrl
  })
}